import { GoogleOAuthProvider } from "@react-oauth/google";
import * as Sentry from "@sentry/react";
import { Loader2 } from "lucide-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { Toaster } from "sonner";

import { ModalConfirmProvider } from "./components/modal-confirm";
import { SessionProvider } from "./components/providers/sessions.tsx";
import { env } from "./libs/env";
import { registerServiceWorker } from "./libs/pwa/register-sw";
import { createRoutesFromFiles} from "./libs/react-router/index.ts";
import { initSentry } from "./libs/sentry";
import TanstackProvider from "./libs/tanstack-query/tanstack-provider.tsx";
import "./middleware.ts";
import "./index.css";

// Must run before the router is created so navigation/tracing is instrumented.
initSentry();
registerServiceWorker();

const pageFiles = import.meta.glob("./app/**/*(page|layout).tsx");
const errorFiles = import.meta.glob("./app/**/*error.tsx");
const notFoundFiles = import.meta.glob("./app/**/*404.tsx");
const loadingFiles = import.meta.glob("./app/**/*loading.tsx");

const routes = createRoutesFromFiles(pageFiles, errorFiles, notFoundFiles, loadingFiles);
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
const router = sentryCreateBrowserRouter([routes]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={env.VITE_GOOGLE_CLIENT_ID ?? ""}>
      <SessionProvider>
        <TanstackProvider>
          <ModalConfirmProvider>
            <RouterProvider
              fallbackElement={
                <div className="flex min-h-screen items-center justify-center bg-gray-50">
                  <div className="flex flex-col items-center gap-3">
                    <Loader2 className="text-primary size-16 animate-spin" />
                    <p className="text-sm text-gray-500">Loading...</p>
                  </div>
                </div>
              }
              router={router}
            />
            <Toaster closeButton position="top-center" richColors />
          </ModalConfirmProvider>
        </TanstackProvider>
      </SessionProvider>
    </GoogleOAuthProvider>
  </StrictMode>
);
